module.exports = __webpack_public_path__ + "media/images/confirmation-3186c706.svg";